import React from 'react';
import {
  Card,
  Grid,
  Segment
} from 'semantic-ui-react';
import ClaimSummary from './ClaimSummary';
import ReceivedEmail from './ReceivedEmail';
import { withApollo, compose, graphql } from 'react-apollo';
import { UpdateDocument } from "../mutations/UpdateDocument";
class InterpretMail extends React.Component {
  state = {}

  handleImportToggle(el) {
    const newStatus = el.status === 'accepted' ? 'discarded' : 'accepted'
    this.setState({loading: true})
    this.props.UpdateDocument({variables: {
      input: {
        document: {
          id: el.id,
          status: newStatus
        }
      }
    }}).then(() => {
      this.setState({loading: false})
    }).catch((error) => {
      console.error(error)
      this.setState({loading: false})
    })
  }

  handleImportAllToggle(accepted) {
    this.props.email.documents.forEach((email) => {
      this.setState({loading: true})
      this.props.UpdateDocument({variables: {
        input: {
          id: email.id,
          status: accepted ? 'accepted' : 'discarded'
        }
      }}).then(() => {
        this.setState({loading: false})
      }).catch((error) => {
        console.error(error)
        this.setState({loading: false})
      })
    })

  }

  render = () => {
    const claim = this.props.claim || {}
    return (
      <Card.Description>
        <Grid padded>
          <Grid.Row>
            <Grid.Column width={5}>
              <ClaimSummary claim={claim}/>
            </Grid.Column>
            <Grid.Column width={11}>
              <Grid>
                <Grid.Row columns={1}>
                  <Grid.Column>
                    {this.renderReceivedEmail()}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Description>
    )
  }

  renderReceivedEmail = () => {
    return (
      <Segment basic loading={this.state.loading}>
        <ReceivedEmail
          email={this.props.email}
          onImportToggleClick={this.handleImportToggle.bind(this)}
          onImportAllToggleClick={this.handleImportAllToggle.bind(this)}
          icon="user"
          toggleImportLabel={this.props.toggleImportLabel}
        />
      </Segment>
    )
  }
}

const InterpretMailWithData = compose(
  withApollo,
  graphql(UpdateDocument, {name: "UpdateDocument"})
)(InterpretMail)

export default InterpretMailWithData



// WEBPACK FOOTER //
// ./src/component/InterpretMail.js